import { render, staticRenderFns } from "./confirmation-snippet.vue?vue&type=template&id=1d9afd71&scoped=true&"
import script from "./confirmation-snippet.vue?vue&type=script&lang=js&"
export * from "./confirmation-snippet.vue?vue&type=script&lang=js&"
import style0 from "./confirmation-snippet.vue?vue&type=style&index=0&id=1d9afd71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9afd71",
  null
  
)

export default component.exports